package es.subastia.data.model

enum class ProvinceDataModel(val nm: String) {
    Alava("Álava"), Albacete("Albacete"), Alicante("Alicante"), Almeria("Almería"), Asturias("Asturias"), Avila("Ávila"),
    Badajoz("Badajoz"), Barcelona("Barcelona"), Burgos("Burgos"), Caceres("Cáceres"), Cadiz("Cádiz"), Cantabria("Cantabria"),
    Castellon("Castellón"), Ceuta("Ceuta"), CiudadReal("Ciudad Real"), Cordoba("Córdoba"), Cuenca("Cuenca"),
    Girona("Girona"), Granada("Granada"), Guadalajara("Guadalajara"), Guipuzcoa("Guipúzcoa"), Huelva("Huelva"),
    Huesca("Huesca"), Baleares("Illes Balears"), Jaen("Jaén"), LaRioja("La Rioja"), LasPalmas("Las Palmas"),
    Leon("León"), Lleida("Lleida"), Lugo("Lugo"), Madrid("Madrid"), Malaga("Málaga"), Melilla("Melilla"),
    Murcia("Murcia"), Navarra("Navarra"), Ourense("Ourense"), Palencia("Palencia"), Pontevedra("Pontevedra"),
    Salamanca("Salamanca"), Segovia("Segovia"), Sevilla("Sevilla"), Soria("Soria"), Tarragona("Tarragona"),
    SantaCruzDeTenerife("Santa Cruz de Tenerife"), Teruel("Teruel"), Toledo("Toledo"), Valencia("Valencia"),
    Valladolid("Valladolid"), Vizcaya("Vizcaya"), Zamora("Zamora"), Zaragoza("Zaragoza");

    companion object {
        fun fromString(text: String): ProvinceDataModel? {
            return entries.find { it.nm.equals(text, ignoreCase = true) }
        }
    }
}
